
<template>
  <div class="tab">
    <div class="tab__left">
      <div class="tab__logo">
        <img class="logo" src="../../assets/images/tab__logo.png" alt />
      </div>
      <div class="tab__list">
        <div
          class="tab__item"
          @click="currentTab(index)"
          :class="{ 'tab__item--active': index == currentIndex }"
          v-for="(item, index) in tabList"
          :key="index"
        >{{ item.name }}</div>
      </div>
    </div>
    <div class="tab__right">
      <div class="user__pic">
        <el-avatar class="avatar" icon="el-icon-user-solid"></el-avatar>
      </div>
      <div class="user__info">
        <el-dropdown @command="handleClick">
          <span class="el-dropdown-link">
            {{ user.userInfo.nickname }}
            <i class="el-icon-caret-bottom el-icon-caret-top"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logOut">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'tab',
  props: {},
  data() {
    return {
      currentIndex: 0,
      tabList: [
        { name: '客户与内容管理后台', link: '' },
        // { name: '云客服管理后台', link: '' },
        // { name: '客服插件', link: '' },
        // { name: '客服消息', link: '' },
        // { name: '小客服移动端', link: '' },
        // { name: '价格', link: '' },
        // { name: '帮助文档', link: '' }
      ]
    }
  },
  computed: {
    ...mapState(['user'])
  },
  mounted() {},
  methods: {
    currentTab(index) {
      this.currentIndex = index
    },
    logOut() {
      this.$store.dispatch('FedLogOut').then(() => {
        this.$router.push({ path: '/login' })
      })
    },
    handleClick(command) {
      this[command]()
    }
  }
}
</script>

<style scoped lang="scss">
.tab {
  height: 80px;
  line-height: 80px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  .tab__left {
    display: flex;
    .tab__logo {
      width: 220px;
      flex-shrink: 0;
      display: flex;
      .logo {
        display: inline-block;
        width: 104px;
        height: 36px;
        align-self: center;
        margin-left: 30px;
      }
    }
    .tab__list {
      display: flex;
      .tab__item {
        cursor: pointer;
        width: auto;
        flex-shrink: 0;
        padding: 0 20px;
        color: #999;
        text-align: center;
        &--active {
          color: #333;
        }
      }
    }
  }
  .tab__right {
    width: 200px;
    display: flex;
    .user__pic {
      display: flex;
      flex-shrink: 0;
      align-self: center;
      .avatar {
        align-self: center;
      }
    }
    .user__info {
      margin-left: 8px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Index/tab.vue